/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================
*/

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import PageLayout from "components/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "components/Footer";

function CoverLayout({ coverHeight, children }) {
  return (
    <PageLayout>
      <MDBox
        width="100vw"
        minHeight={coverHeight}
        display="flex"
        flexDirection="column"
        sx={{
          // Aplicamos el degradado idéntico al Sidenav
          backgroundImage: ({ functions: { linearGradient }, palette: { gradients } }) =>
            linearGradient(gradients.dark.main, gradients.dark.state),
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {/* Contenedor principal con Flex 1 para empujar el footer al fondo */}
        <MDBox
          flex={1}
          display="flex"
          alignItems="center" // Centrado Vertical
          justifyContent="center" // Centrado Horizontal
          width="100%"
        >
          <MDBox px={1} width="100%">
            <Grid container justifyContent="center">
              <Grid size={{ xs: 11, sm: 9, md: 5, lg: 4, xl: 3 }}>{children}</Grid>
            </Grid>
          </MDBox>
        </MDBox>

        {/* Footer siempre al final del viewport */}
        <MDBox width="100%" pb={3}>
          <Footer light />
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

CoverLayout.defaultProps = {
  coverHeight: "100vh",
};

CoverLayout.propTypes = {
  coverHeight: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
